module.exports = __webpack_public_path__ + "static/media/projectLogo.330e1d36.jpg";